/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/hanger_medium'
export default icon
